import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const ChatSendIcon = ()=>/*#__PURE__*/ jsxs("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
                fill: "#0068EF"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M17.0002 23V11.83L21.8802 16.71C22.2702 17.1 22.9102 17.1 23.3002 16.71C23.6902 16.32 23.6902 15.69 23.3002 15.3L16.7102 8.70998C16.3202 8.31998 15.6902 8.31998 15.3002 8.70998L8.70021 15.29C8.31021 15.68 8.31021 16.31 8.70021 16.7C9.09021 17.09 9.72022 17.09 10.1102 16.7L15.0002 11.83V23C15.0002 23.55 15.4502 24 16.0002 24C16.5502 24 17.0002 23.55 17.0002 23Z",
                fill: "white"
            })
        ]
    });
const svgs_ChatSendIcon = ChatSendIcon;
export { svgs_ChatSendIcon as default };
